@if (contactType===ContactCategory.PEOPLE && !(contactService.loading$ | async)) {
  <div class="container">
    <h1 class="title-header">{{ (contactService.person$ | async)?.name }}</h1>
    <h4 class="title-subheader">General Information</h4>
    <div><b>Name:</b> {{(contactService.person$ | async)?.name}}</div>
    @if (contactService.person$ | async; as person) {
      <div><b>Employer: </b> <a href="{{dataFormat.formatLink($safeNavigationMigration(person?.employees?.[0].organization))}}" class="data-link">{{person?.employees?.[0].organization.name}}</a></div>
    }
    <div><b>Job Title:</b> {{(contactService.person$ | async)?.employees?.[0].title}}</div>
    <h4>Tags</h4>
    @if (contactService.person$ | async; as person) {
      <div>
        @for (ts of person.entity.entity_types; track ts) {
          <mat-chip-row>
            <mat-chip class="chip-size">
              {{ts.type.name}}
            </mat-chip>
          </mat-chip-row>
        }
      </div>
    }
    @if ((contactService.person$ | async)?.entity?.entityEmailAddresses.length) {
      <h4>Email Addresses</h4>
      @for (email of (contactService.person$ | async)?.entity.entityEmailAddresses; track email) {
        <div>
          <div>@if (email.name!==null) {
            <b>{{email.name}}</b>
          }: {{email.emailAddress.emailaddress}}</div>
        </div>
      }
    }
    @if ((contactService.person$ | async)?.entity.entityPhoneNumbers.length) {
      <h4>Phone Numbers</h4>
      @for (number of (contactService.person$ | async)?.entity.entityPhoneNumbers; track number) {
        <div>
          <div>@if (number.name!==null) {
            <b>{{number.name}}: </b>
          } {{dataFormat.phoneFormat(number.phoneNumber.area_code, number.phoneNumber.phone_number)}}</div>
        </div>
      }
    }
    @if ((contactService.person$ | async)?.entity.entityAddresses.length) {
      <h4>Addresses</h4>
      @for (address of (contactService.person$ | async)?.entity.entityAddresses; track address) {
        <div>
          <div>@if (address.name!==null) {
            <b>{{address.name}}: </b>
          }{{renderAddress(address)}}</div>
        </div>
      }
    }
    @if (companyEventDataSource.data.length) {
      <h4>Upcoming Company Events</h4>
      <table mat-table class="stripped-table mat-elevation-z2" [dataSource]="companyEventDataSource" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Event</th>
          <td mat-cell *matCellDef="let row"><a href="{{row.url}}" class="data-link" target="_blank">{{row.name}}</a></td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Date/Time</th>
          <td mat-cell *matCellDef="let row">{{
            row.start_date.includes(':')
            ? (row.start_date | date: 'MM/dd/yyyy hh:mm a') : (row.start_date | date: 'MM/dd/yyyy')
            }} - {{
            row.end_date.includes(':')
            ? (row.end_date | date: 'MM/dd/yyyy hh:mm a' ) : (row.end_date | date: 'MM/dd/yyyy')
          }}</td>
        </ng-container>
        <ng-container matColumnDef="registered">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Registration Status</th>
          <td mat-cell *matCellDef="let row">{{row.is_registered ? 'Registered' : 'Unregistered'}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef=companyEventColumns></tr>
        <tr mat-row *matRowDef="let row; columns: companyEventColumns"></tr>
      </table>
    }
    @if (contactService.associatedDeals$ | async; as dealList) {
      @if (dealList.length) {
        <div>
          <div class="row">
            <div class="col-11">
              <h4>Associated Deals</h4>
            </div>
            <div class="col-1">
              <button class="show-hide-btn" (click)="toggleView('deal')">{{ showDeals ? 'Hide Deals' : 'Show Deals' }}</button>
            </div>
          </div>
          <mat-divider></mat-divider>
          @if (showDeals) {
            <div style="margin-top: 10px">
              <contact-deals-table [deals]="dealList" [pageInfo]="(contactService.projectPageData$ | async)" (paginate)="getPage($event)" [totals]="(contactService.totals$ | async)"></contact-deals-table>
            </div>
          }
        </div>
      }
    }
    @if (contactService.deadDeals$ | async; as deadDealList) {
      @if (deadDealList.length) {
        <div>
          <div class="row">
            <div class="col-11">
              <h4>Dead Deals</h4>
            </div>
            <div class="col-1">
              <button class="show-hide-btn" (click)="toggleView('dead')">{{ showDeadDeals ? 'Hide Deals' : 'Show Deals' }}</button>
            </div>
          </div>
          <mat-divider></mat-divider>
          @if (showDeadDeals) {
            <div style="margin-top: 10px">
              <contact-deals-table [deals]="deadDealList" [pageInfo]="(contactService.deadProjectPageData$ | async)" (paginate)="getPage($event)" [totals]="(contactService.deadTotals$ | async)"></contact-deals-table>
            </div>
          }
        </div>
      }
    }
    @if (contactService.outlets$ | async; as outletList) {
      @if (outletList.length>0) {
        <div>
          <h4>Associated Outlets</h4>
          <contacts-outlets-table [outletParticipants]="(contactService.outlets$ | async) ?? []"></contacts-outlets-table>
        </div>
      }
    }
  </div>
}
@if (contactType===ContactCategory.ORGANIZATIONS && !(contactService.loading$ | async)) {
  <div class="container">
    <h1 class="title-header">{{(contactService.organization$ | async)?.name}}</h1>
    <h4>Tags</h4>
    @if (contactService.organization$ | async; as org) {
      <div>
        @for (ts of org.entity?.entity_types; track ts) {
          <mat-chip-row>
            <mat-chip class="chip-size">
              {{ts.type.name}}
            </mat-chip>
          </mat-chip-row>
        }
      </div>
    }
    @if ((contactService.organization$ | async)?.sponsor) {
      <h4>Sponsor</h4>
      <div><a href="{{dataFormat.formatLink($safeNavigationMigration((contactService.organization$ | async)?.sponsor))}}" class="data-link" target="_blank">{{(contactService.organization$ | async)?.sponsor?.name}}</a></div>
    }
    @if ((contactService.organization$ | async)?.sponsor?.originatorRelationship) {
      <h4>Sponsor's Originator Relationship</h4>
      <div><a href="{{dataFormat.formatLink($safeNavigationMigration((contactService.organization$ | async)?.sponsor?.originatorRelationship?.person))}}" class="data-link" target="_blank">{{(contactService.organization$ | async)?.sponsor?.originatorRelationship?.person?.name}}</a> ({{(contactService.organization$ | async)?.sponsor?.originatorRelationship?.is_originated ? "Originated" : "Assigned"}})</div>
    }
    @if ((contactService.organization$ | async)?.entity?.entityAddresses?.length) {
      <h4>Addresses</h4>
      @for (address of (contactService.organization$ | async)?.entity?.entityAddresses; track address) {
        <div>
          <div>@if (address.name!==null) {
            <b>{{address.name}}:</b>
          } {{dataFormat.formatAddress(address.address)}}</div>
        </div>
      }
    }
    @if ((contactService.organization$ | async)?.entity?.entityPhoneNumbers?.length) {
      <h4>Phone Numbers</h4>
      @for (number of (contactService.organization$ | async)?.entity?.entityPhoneNumbers; track number) {
        <div>
          <div>@if (number.name!==null) {
            <b>{{number.name}}: </b>
          } {{dataFormat.phoneFormat($safeNavigationMigration(number.phoneNumber?.area_code), number.phoneNumber.phone_number)}}</div>
        </div>
      }
    }
    @if ((contactService.organization$ | async)?.entity?.entityWebAddresses?.length) {
      <h4>Web Addresses</h4>
      @for (website of (contactService.organization$ | async)?.entity?.entityWebAddresses; track website) {
        <div>
          <div>@if (website.name!==null) {
            <b>{{website.name}}: </b>
            }<a href="{{dataFormat.formatWeblink(website.webAddress)}}" target="_blank" class="data-link">{{dataFormat.formatWeblink(website.webAddress)}}</a></div>
          </div>
        }
      }
      @if (contactService.associatedDeals$ | async; as dealList) {
        @if (dealList.length) {
          <div>
            <div class="row">
              <div class="col-11">
                <h4>Associated Deals</h4>
              </div>
              <div class="col-1">
                <button class="show-hide-btn" (click)="toggleView('deal')">{{ showDeals ? 'Hide Deals' : 'Show Deals' }}</button>
              </div>
            </div>
            <mat-divider></mat-divider>
            @if (showDeals) {
              <div style="margin-top: 10px">
                <contact-deals-table [deals]="dealList" [pageInfo]="(contactService.projectPageData$ | async)" (paginate)="getPage($event)" [totals]="(contactService.totals$ | async)"></contact-deals-table>
              </div>
            }
          </div>
        }
      }
      @if (contactService.deadDeals$ | async; as deadDealList) {
        @if (deadDealList.length) {
          <div>
            <div class="row">
              <div class="col-11">
                <h4>Dead Deals</h4>
              </div>
              <div class="col-1">
                <button class="show-hide-btn" (click)="toggleView('dead')">{{ showDeadDeals ? 'Hide Deals' : 'Show Deals' }}</button>
              </div>
            </div>
            <mat-divider></mat-divider>
            @if (showDeadDeals) {
              <div style="margin-top: 10px">
                <contact-deals-table [deals]="deadDealList" [pageInfo]="(contactService.deadProjectPageData$ | async)" (paginate)="getPage($event)" [totals]="(contactService.deadTotals$ | async)"></contact-deals-table>
              </div>
            }
          </div>
        }
      }
      @if (contactService.fundInvestments$ | async; as fundlist) {
        @if (fundlist.length) {
          <div>
            <h4>Fund Investments</h4>
            <contacts-fund-investors-table [fundInvestments]="fundlist"></contacts-fund-investors-table>
          </div>
        }
      }
      @if ((contactService.organization$ | async)?.employees?.length) {
        <h4>Employees</h4>
        <table mat-table class="stripped-table mat-elevation-z2" [dataSource]="getEmployeeSource()" matSort>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let row"><a href="{{row.url}}" class="data-link" target="_blank">{{row.name}}</a></td>
          </ng-container>
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
            <td mat-cell *matCellDef="let row">{{row.title}}</td>
          </ng-container>
          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
            <td mat-cell *matCellDef="let row">{{row.phone}}</td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let row"><a href="mailto:{{row.email}}" class="data-link">{{row.email}}</a></td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef=employeesColumns></tr>
          <tr mat-row *matRowDef="let row; columns: employeesColumns"></tr>
        </table>
      }
    </div>
  }
  @if (contactType===ContactCategory.SPONSORS && !(contactService.loading$ | async)) {
    <div class="container">
      <h1 class="title-header">{{(contactService.sponsor$ | async)?.name}}</h1>
      <div>Relationship Name: {{(contactService.sponsor$ | async)?.nickname}}</div>
      @if ((contactService.sponsor$ | async) && (contactService.sponsor$ | async)?.originatorRelationship) {
        <h4>Originator Relationship</h4>
      }
      @if ((contactService.sponsor$ | async); as sponsor) {
        <div><a href="{{sponsor && sponsor?.originatorRelationship ? dataFormat.formatLink($safeNavigationMigration(sponsor?.originatorRelationship?.person)) : ''}}" class="data-link" target="_blank">{{sponsor?.originatorRelationship?.person?.name}}</a> ({{sponsor?.originatorRelationship?.is_originated ? "Originated" : "Assigned"}})</div>
      }
      @if ((contactService.associatedDeals$ | async); as dealList) {
        @if (dealList.length > 0) {
          <div>
            <div class="row">
              <div class="col-11">
                <h4>Sponsored Deals</h4>
              </div>
              <div class="col-1">
                <button class="show-hide-btn" (click)="toggleView('deal')">{{ showDeals ? 'Hide Deals' : 'Show Deals' }}</button>
              </div>
            </div>
            <mat-divider></mat-divider>
            @if (showDeals) {
              <div style="margin-top: 10px">
                <contact-deals-table [deals]="dealList" [pageInfo]="(contactService.projectPageData$ | async)" (paginate)="getPage($event)" [totals]="(contactService.totals$ | async)"></contact-deals-table>
              </div>
            }
          </div>
        }
      }
      @if ((contactService.deadDeals$ | async); as deadDealList) {
        @if (deadDealList.length) {
          <div>
            <div class="row">
              <div class="col-11">
                <h4>Dead Deals</h4>
              </div>
              <div class="col-1">
                <button class="show-hide-btn" (click)="toggleView('dead')">{{ showDeadDeals ? 'Hide Deals' : 'Show Deals' }}</button>
              </div>
            </div>
            <mat-divider></mat-divider>
            @if (showDeadDeals) {
              <div style="margin-top: 10px">
                <contact-deals-table [deals]="deadDealList" [pageInfo]="(contactService.deadProjectPageData$ | async)" (paginate)="getPage($event)" [totals]="(contactService.deadTotals$ | async)"></contact-deals-table>
              </div>
            }
          </div>
        }
      }
      @if ((contactService.sponsorDeals$ | async); as spDealList) {
        <div>
          <div class="row">
            <div class="col-11">
              <h4>Associated Deals</h4>
            </div>
            <div class="col-1">
              <button class="show-hide-btn" (click)="toggleView('sponsor')">{{ showSponsorDeals ? 'Hide Deals' : 'Show Deals' }}</button>
            </div>
          </div>
          <mat-divider></mat-divider>
          @if (showSponsorDeals) {
            <div style="margin-top: 10px">
              @if (!!(contactService.sponsorTableLoading$ | async)) {
                <div style="display: flex; justify-content: center; align-items: center; height: 150px;">
                  <mat-progress-spinner diameter="30" mode="indeterminate"></mat-progress-spinner>
                </div>
              }
              @if (!(contactService.sponsorTableLoading$|async)) {
                <div>
                  <contact-deals-table [deals]="spDealList" [pageInfo]="(contactService.sponsorProjectPageData$ | async)" (paginate)="getAssociatedDealsPage($event)" [totals]="(contactService.sponsorOrgTotals$ | async)" [isSponsorAssociatedTable]="true"></contact-deals-table>
                </div>
              }
            </div>
          }
        </div>
      }
      @if ((contactService.deadSponsorDeals$ | async); as spDeadDealList) {
        <div>
          <div class="row">
            <div class="col-11">
              <h4>Dead Associated Deals</h4>
            </div>
            <div class="col-1">
              <button class="show-hide-btn" (click)="toggleView('deadSponsor')">{{ showDeadSponsorDeals ? 'Hide Deals' : 'Show Deals' }}</button>
            </div>
          </div>
          <mat-divider></mat-divider>
          @if (showDeadSponsorDeals) {
            <div style="margin-top: 10px">
              @if ((contactService.sponsorTableLoading$ | async)) {
                <div style="display: flex; justify-content: center; align-items: center; max-height: 300px;">
                  <mat-progress-spinner diameter="30" mode="indeterminate"></mat-progress-spinner>
                </div>
              }
              @if (!(contactService.sponsorTableLoading$ | async)) {
                <div>
                  <contact-deals-table [deals]="spDeadDealList" [pageInfo]="(contactService.deadSponsorProjectPageData$ | async)" (paginate)="getAssociatedDealsPage($event)" [totals]="(contactService.deadOrgTotals$ | async)" [isSponsorAssociatedTable]="true"></contact-deals-table>
                </div>
              }
            </div>
          }
        </div>
      }
      <h4>Sponsored Organizations</h4>
      @for (org of contactService.sponsorOrgs$ | async; track org) {
        <div>
          <div><a href="{{dataFormat.formatLink(org)}}" class="data-link" target="_blank">{{org.name}}</a></div>
        </div>
      }
      @if (contactService.fundInvestments$ | async; as fundlist) {
        @if (fundlist.length) {
          <div>
            <h4>Fund Investments</h4>
            <contacts-fund-investors-table [fundInvestments]="fundlist"></contacts-fund-investors-table>
          </div>
        }
      }
    </div>
  }

